import type {DeclineTaskPath, DeclineTaskResponse} from '../../http';
import {declineTask} from '../../http';
import {useMutation, useQueryClient} from 'react-query';

export function useDeclineTask() {
	const queryClient = useQueryClient();

	return useMutation<DeclineTaskResponse, unknown, DeclineTaskPath>({
		mutationFn: async (path) => {
			const {data} = await declineTask(path);
			return data;
		},
		onSuccess: (task) => {
			queryClient.setQueryData(['task', task.id], task);
			queryClient.invalidateQueries({queryKey: ['tasks']});
		},
	});
}
